import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import IconCarbonTaskAdd from '@/shared/icons/IconCarbonTaskAdd'
import { Card, Header1 } from '@/shared/theme/styled-components'

import AddEditModal from './AddEditModal'
import RevealPasswordModal from './RevealPasswordModal'
import useWebsalesUsersManagement from './useWebsalesUsersManagement'
import { HeaderRow } from './styled-components'
import WebsalesTableBody from './table/WebsalesTableBody'
import {
  ActionsTh,
  CreatedAtTh,
  IdTh,
  StatusTh,
  Table,
  TableWrap,
  TheadRow,
  UsernameTh,
} from './table/styled-components'

const WebsalesUsersManagement = () => {
  const {
    websalesUsers,
    modalTitle,
    websalesUsersListIsLoading,
    websalesUsersError,
    canDelete,
    t,
    close,
    isOpen,
    setIsOpen,
    revealedPassword,
    closeRevealedPassword,
    updateWebsalesUser,
    toggleStatus,
    deleteWebsalesUser,
    regeneratePassword,
  } = useWebsalesUsersManagement()

  return (
    <Card>
      <HeaderRow>
        <Header1 id='websales-users-title'>{t('websalesUsersManagement:title')}</Header1>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton
          block={false}
          onClick={() => updateWebsalesUser(null)}
          endEnhancer={() => <IconCarbonTaskAdd size={16} color='white' />}
        >
          {t('websalesUsersManagement:create_button')}
        </SDButton>
      </HeaderRow>

      <SDNotification type='negative' hidden={!websalesUsersError} primaryText={String(websalesUsersError || '')} />

      <SDLoader hidden={!websalesUsersListIsLoading} text={t('common:fetching_data')} />

      <TableWrap hidden={websalesUsersListIsLoading}>
        <Table>
          <thead>
            <TheadRow>
              <IdTh>{t('websalesUsersManagement:table.id')}</IdTh>
              <UsernameTh>{t('websalesUsersManagement:table.username')}</UsernameTh>
              <StatusTh>{t('websalesUsersManagement:table.status')}</StatusTh>
              <CreatedAtTh>{t('websalesUsersManagement:table.created_at')}</CreatedAtTh>
              <ActionsTh>{t('websalesUsersManagement:table.actions')}</ActionsTh>
            </TheadRow>
          </thead>
          <tbody>
            <WebsalesTableBody
              websalesUsers={websalesUsers}
              canDelete={canDelete}
              t={t}
              onEdit={updateWebsalesUser}
              onToggleStatus={toggleStatus}
              onDelete={deleteWebsalesUser}
              onRegeneratePassword={regeneratePassword}
            />
          </tbody>
        </Table>
      </TableWrap>

      <SDModal
        isOpen={isOpen}
        openHandler={setIsOpen}
        title={modalTitle}
        sections={<AddEditModal setIsOpen={setIsOpen} close={close} />}
      />

      <RevealPasswordModal password={revealedPassword} onClose={closeRevealedPassword} />
    </Card>
  )
}

export default WebsalesUsersManagement
